import React, { useEffect, useRef, useState, useContext } from "react";
import { useHistory } from "react-router";
import CaseProgressSearch from './CaseProgressSearch'
import CaseProgressList from "./CaseProgressList";
import { getCaseProgress, CheckCaptcha } from "./CaseProgress.service";
import { useTranslation } from "react-i18next";
import { showGlobalMessageBox } from 'src/Route/RootMiddleware';
import { SignInStatusContext } from "../../Basic/BasicData";

const Query = (props) => {

    //首次載入
    const [firstLoad, setFirstLoad] = useState(true);
    //元件切換
    const [isSearch, setIsSearch] = useState(true);
    //搜尋方式
    const [caseType, setCaseType] = useState('');
    //grid資料
    const [gridData, setGridData] = useState([]);

    const RootHistory = useHistory();

    const { signInStatus, setSignInStatus } = useContext(SignInStatusContext);

    const { t } = useTranslation();

    useEffect(() => {
        if (firstLoad) {
            setFirstLoad(false);
        }
    }, [])

    /**
     * 處理submit回傳資料
     * @param {Array} data api回傳grid資料
     * @param {string} type 搜尋方式
     */
    const onSubmit = async (data) => {
        if (data.OrgSys == 'DSIC') {
            setCaseType('一般申請案件')
        }
        if (data.OrgSys == 'OLAP') {
            setCaseType('線上申辦查詢')
        }
        if (data.OrgSys == 'NIA') {
            setCaseType('大陸人士查詢')
        }
        const PostNo =
            data.postOfficeBarcode?.trim() ||
            data.diliverBarcode?.trim() ||
            '';

        const submitData = {
            ...data,
            PostNo,
        };
        //驗證驗證碼
        let captchaResult = await CheckCaptcha(submitData);
        //查詢
        if (captchaResult.success) {
            let result = await getCaseProgress(submitData);
            setGridData(result)
            setIsSearch(false);
        }
        else {
            showGlobalMessageBox(captchaResult.message);
        }

    }

    return (
        <>
            <div className="fnFormScroll">
                <div className="page-scrollbar">
                    <div className="container_90">
                        <div>
                            <div>
                                <div className="text-center">
                                    <div className="top_green_bg">
                                        {caseType == '' ?
                                            <div className="top_green_bg_return font_14_500" onClick={() => {
                                                if (signInStatus) {
                                                    RootHistory.push("/Home");
                                                } else {
                                                    RootHistory.push("/");
                                                }
                                            }}>返回首頁</div>
                                            :
                                            <div className="top_green_bg_return font_14_500" onClick={() => {
                                                setIsSearch(true);
                                                setCaseType('');
                                                setGridData([]);
                                            }}>返回案件進度查詢</div>
                                        }
                                        <div className="text-center">
                                            <div className="top_green_bg_green_font "></div>
                                            {caseType == '' ?
                                                <div className="top_green_bg_white_font28">案件進度查詢</div>
                                                :
                                                <div className="top_green_bg_white_font28">案件詳細處理情形</div>
                                            }
                                            <div className="top_green_bg_white_font24">{caseType}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center">
                                    {/* 元件切換 */}
                                    {isSearch ?
                                        <CaseProgressSearch
                                            onSubmit={onSubmit}
                                        />
                                        :
                                        <CaseProgressList
                                            gridData={gridData}
                                        />
                                    }
                                    <p>{t('moea_ic.footer.issue')}<br></br>{t('moea_ic.footer.hotline')}：moea_ic_service@gss.com.tw｜{t('moea_ic.footer.hotline2')}｜{t('moea_ic.footer.serviceHour')} 9:00-17:30</p>
                                    < p > {t('moea_ic.footer.address')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Query